import styled from 'styled-components'
import { breakpoints, theme } from '../ui-config'

export const H1 = styled.h1`
    font-size: 7rem;
    margin: 2rem 0;
    position: relative;
    left: -4px;

    @media (max-width: ${breakpoints.small}px) {
        font-size: 4rem;
        line-height: 5rem;
    }
`
export const H3 = styled.h3`
    font-size: 2.8rem;
    line-height: 4.2rem;
    font-weight: 300;
    margin: 1rem 0;

    @media (max-width: ${breakpoints.small}px) {
        font-size: 2rem;
        line-height: 3.2rem;
    }
`

export const SectionalHeader = styled.div`
    color: ${theme.coloredHeaders};
    text-transform: uppercase;
`

export const CalloutParagraph = styled.p`
    font-size: 2.6rem;
    line-height: 5.2rem;

    @media (max-width: ${breakpoints.small}px) {
        font-size: 2.4rem;
        line-height: 4.2rem;
    }
`



// WEBPACK FOOTER //
// ./src/components/core.js